import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Http from "../../../../commons/utils/Http";
import ButtonAction from "../../../../commons/components/buttonAction";
import CardContainer from "../../../../commons/components/cardContainer"
import Loading from "../../../../commons/components/loading";

import {
    accessManagementSetSelectedPartner,
    accessManagementSetShowPartners,
    accessManagementSetShowUsers,
    accessManagementSetFilterApplication,
    accessManagementSetEditApplication
} from '../../../../store/actions/accessManagementActions';

import {
    ListCard,
    MessageContainer,
} from './cardPartnersStyles';

function CardPartners(props) {
    const dispatch = useDispatch();
    const userId = useSelector(state => state.userLogin.userData.id);
    const { screens } = useSelector(state => state.userLogin);

    const [permissions] = useState([]);
    const [partnersData, setPartnersData] = useState([])
    
    const [loading, setLoading] = useState(false);

    const { searchPartner } = useSelector(state => state.accessManagement);

    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/users") {
                    screen.functions.map(_function => {
                        if (!permissions.find(permission => permission.function_id == _function.function_id)) {
                            permissions.push(_function);
                        }
                    })
                }
            });
        }
    }, [screens]);

    useEffect(() => {
        if (userId) {
            getPartnersOrSearch(searchPartner);
        }
    }, [searchPartner, userId]);

    function getPartnersOrSearch(search) {
        if (search === "") {
            getPartners();
        } else {
            searchPartners(search)
        }
    }

    function getPartners() {
        setLoading(true);
        
        Http.get(`/partners/partners-by-admin-user?user_id=${userId}`, Http.headers)
            .then(response => {
                const responseData = response.data

                if (!responseData.response.error) {
                    setPartnersData(responseData.data);
                    setLoading(false);
                }
            }).catch(err => {
                setPartnersData([]);
                setLoading(false);
            })
    }

    function searchPartners(search) {
        Http.get(`/partners/partners-by-admin-user?user_id=${userId}&search=${search}`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    setPartnersData(responseData.data);
                    setLoading(false);
                }
            }).catch(err => {
                setPartnersData([]);
                setLoading(false);
            })
    };


    function handleEditPartner(partner) {
        dispatch(accessManagementSetShowPartners(false));
        dispatch(accessManagementSetShowUsers(true));
        dispatch(accessManagementSetSelectedPartner(partner));
        dispatch(accessManagementSetFilterApplication({ key: "", value: "", children: "" }));
        dispatch(accessManagementSetEditApplication(true));
    }

    const renderCards = () => {
        if (loading) {
            return (
                <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                    <Loading width={50} height={50} />
                </div>
            )
        } else {
            return (
                partnersData.length > 0 ?
                    <ListCard>
                        {partnersData.map((partner, key) => {
                            return (
                                <CardContainer key={key} style={{ marginRight: 16, minWidth: 450 }}>
                                    <strong className="partner-name">{partner.nome || partner.trading_name || "Nome não encontrado"}</strong>

                                    <p className="partner-details">
                                        <strong className="partner-description">CNPJ:</strong> <span className="partner-description-val">{partner.cnpj || partner.identification_number || "CNPJ não encontrado"}</span><br />
                                        <strong className="partner-description">Razão social:</strong> <span className="partner-description-val">{partner.razaoSocial || partner.company_name || "Razão social não encontrada"}</span><br />
                                        <strong className="partner-description">Equipe:</strong> <span className="partner-description-val">{partner.number_users ? partner.number_users + " pessoas" : "Número da equipe não encontrado"}</span>
                                    </p>

                                    <ButtonAction type="edit" text="Editar Empresa" borderRadius="50" callback={() => handleEditPartner(partner)} />
                                </CardContainer>
                            )
                        })}
                    </ListCard>
                    :
                    <MessageContainer>
                        No momento você ainda não possui permissão para gerenciar nenhuma empresa
                    </MessageContainer>
            )
        }
    };

    return (
        renderCards()
    )
}

export default CardPartners;
